import { render } from "./AddressDisplay.vue?vue&type=template&id=9f0e51fe"
import script from "./AddressDisplay.vue?vue&type=script&lang=js"
export * from "./AddressDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__